'use client';

import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import ProductHighlights from '../components/ProductHighlights';
// import Testimonials from '../components/Testimonials';
import NewsletterSignup from '../components/NewsletterSignup';
import SEOOptimized, { localBusinessSchema } from '../components/SEOOptimized';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SEOOptimized 
        title="Nirvana Ayurveda - Ancient Wisdom, Modern Wellness | Best Ayurvedic Clinic UK"
        description="Leading Ayurveda clinic in UK offering natural health solutions for weight management, joint pain relief, and holistic wellness. Expert Ayurvedic treatments with proven results. Book consultation today."
        keywords="ayurveda UK, ayurvedic treatment UK, natural health UK, holistic wellness, weight management ayurveda, joint pain relief natural, herbal medicine UK, ayurvedic doctor UK, natural remedies UK, wellness center UK, ayurvedic clinic UK, traditional medicine UK"
        canonical="https://nirvanaayurveda.infy.uk"
        schemaType="MedicalBusiness"
        schemaData={localBusinessSchema}
      />
      <Header />
      <main>
        <HeroSection />
        <ProductHighlights />
        {/* <Testimonials /> */}
        <NewsletterSignup />
      </main>
      <Footer />
    </div>
  );
}
